import { useEffect } from "react";
import { useMultiCashoutEnabled } from "../../hooks/useMultiCashoutEnabled";
import { ROUTES } from "../../setup/constants";
import { useNavigate } from "react-router-dom";
import MultiCashouts from "./MultiCashouts";
import Spinner from "../../components/common/Spinner";
import styles from "./cashouts.module.scss";

const MultiCashoutsPage = () => {
  const { isMultiCashoutEnabled, isLoadingMultiCashoutFlag } =
    useMultiCashoutEnabled();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isMultiCashoutEnabled && !isLoadingMultiCashoutFlag) {
      navigate(ROUTES.CONTRACT_NOT_FOUND, { replace: true });
    }
  }, [isLoadingMultiCashoutFlag, isMultiCashoutEnabled, navigate]);

  if (isLoadingMultiCashoutFlag) {
    return (
      <div className={styles.loading_container}>
        <Spinner />
      </div>
    );
  }

  if (!isMultiCashoutEnabled) {
    return null;
  }

  return <MultiCashouts />;
};

export default MultiCashoutsPage;
